import nl from '~public/images/hero-warm-home-20261018.jpg';
import nlWebp from '~public/images/hero-warm-home-20261018.jpg?format=webp';
import be from '~public/images/hero-be-20261018.jpg';
import beWebp from '~public/images/hero-be-20261018.jpg?format=webp';
import fr from '~public/images/hero-fr-20261018.jpg';
import frWebp from '~public/images/hero-fr-20261018.jpg?format=webp';
import es from '~public/images/hero-es-20261018.jpg';
import esWebp from '~public/images/hero-es-20261018.jpg?format=webp';
import pt from '~public/images/hero-pt-20261018.jpg';
import ptWebp from '~public/images/hero-pt-20261018.jpg?format=webp';
import de from '~public/images/hero-de-20261018.jpg';
import deWebp from '~public/images/hero-de-20261018.jpg?format=webp';
import en from '~public/images/hero-en-20261018.jpg';
import enWebp from '~public/images/hero-en-20261018.jpg?format=webp';
import it from '~public/images/hero-it-20261018.jpg';
import itWebp from '~public/images/hero-it-20261018.jpg?format=webp';
import no from '~public/images/hero-no-20261018.jpg';
import noWebp from '~public/images/hero-no-20261018.jpg?format=webp';
import cs from '~public/images/hero-cs-20261018.jpg';
import csWebp from '~public/images/hero-cs-20261018.jpg?format=webp';
import pl from '~public/images/hero-pl-20261018.jpg';
import plWebp from '~public/images/hero-pl-20261018.jpg?format=webp';
import ro from '~public/images/hero-ro-20261018.jpg';
import roWebp from '~public/images/hero-ro-20261018.jpg?format=webp';
import ru from '~public/images/hero-ru-20261018.jpg';
import ruWebp from '~public/images/hero-ru-20261018.jpg?format=webp';
import uk from '~public/images/hero-uk-20261018.jpg';
import ukWebp from '~public/images/hero-uk-20261018.jpg?format=webp';
import tr from '~public/images/hero-tr-20261018.jpg';
import trWebp from '~public/images/hero-tr-20261018.jpg?format=webp';
import ja from '~public/images/hero-ja-20261018.jpg';
import jaWebp from '~public/images/hero-ja-20261018.jpg?format=webp';
import vi from '~public/images/hero-vi-20261018.jpg';
import viWebp from '~public/images/hero-vi-20261018.jpg?format=webp';
import bn from '~public/images/hero-bn-20261018.jpg';
import bnWebp from '~public/images/hero-bn-20261018.jpg?format=webp';
const images = {nl: {picture: nl, pictureWebp: nlWebp},be: {picture: be, pictureWebp: beWebp},fr: {picture: fr, pictureWebp: frWebp},es: {picture: es, pictureWebp: esWebp},pt: {picture: pt, pictureWebp: ptWebp},de: {picture: de, pictureWebp: deWebp},en: {picture: en, pictureWebp: enWebp},it: {picture: it, pictureWebp: itWebp},no: {picture: no, pictureWebp: noWebp},cs: {picture: cs, pictureWebp: csWebp},pl: {picture: pl, pictureWebp: plWebp},ro: {picture: ro, pictureWebp: roWebp},ru: {picture: ru, pictureWebp: ruWebp},uk: {picture: uk, pictureWebp: ukWebp},tr: {picture: tr, pictureWebp: trWebp},ja: {picture: ja, pictureWebp: jaWebp},vi: {picture: vi, pictureWebp: viWebp},bn: {picture: bn, pictureWebp: bnWebp}};
export const marketImages = locale => {
  const normalized = String(locale || 'nl-NL').toLowerCase().replace('_', '-');
  const language = normalized.split('-')[0];
  const key = normalized === 'nl-be' ? 'be' : language;
  return images[key] || images.en;
};
